<template>
    <b-modal
      ref="alertModal"
      centered
      :title="title"
      :header-bg-variant="variant"
      header-text-variant="white"
      size="xl"
      ok-only
    >
    <p class="my-4">
        <ul>
            <li v-for="item in alertMessage" :key="item">{{ item }}</li>
        </ul>
    </p>
  </b-modal>
</template>

<script>

export default {
    name: "alert-popup",
    props: {
        title: String,
        alertMessage: String(),
        // primary=blue, danger=red, success=green, secondary=grey, warning=yellow, info=teal?, light=white, and dark=black.
        variant: { type: String, default: "primary" }
    },
    data: function () {
        return {

        };
    },
    mounted: function () {
        //mounted is an event in the lifecyle of a vue component
        },
    computed: {

    },
    watch: {

    },
    methods: {
        showModal(title, alertText, colorOfPopup) {
            var vm = this;
            vm.title = title;
            vm.variant = colorOfPopup;
            vm.alertMessage = alertText.split(';');
        
            vm.$refs['alertModal'].show()
        },
        hideModal() {
            var vm = this;
            vm.$refs['alertModal'].hide()
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >
ul {
    text-align: left;
}

li {
    margin: 10px 20px;
}
::v-deep .h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {
    margin-bottom: .5rem;
    font-weight: 500;
    line-height: 1.2;
}
::v-deep .h5, h5 {
    font-size: 1.25rem;
}

::v-deep .modal-content {
    line-height: 1.5; 
    font: 16px "Helvetica Neue", Helvetica, Arial, sans-serif !important}

</style>
